import _extends from "@babel/runtime/helpers/extends";
import React, { Fragment } from "react";
import getIconButtonProps from "./logic";
import { BaseIconButtonCell } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
export default function RowActionsCell(props) {
  var getRowActions = Object.keys(props).map(function (action) {
    var actionProps = props[action];
    var iconButtonProps = getIconButtonProps(actionProps, action);
    return /*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsx(BaseIconButtonCell, _extends({}, iconButtonProps))
    }, action);
  });
  return getRowActions;
}